import { type DeepReadonly } from "./utils/types";

import { type RouteConfigEntry } from "@react-router/dev/routes";

// TODO: Consider checking for topas2 routes and redirecting to / for trainInsights users
export const TRAIN_INSIGHTS_SELF_DEFINED_ROUTES = [
  {
    file: "./routes/_authenticated.tsx",
    id: "trainInsightsAuthenticated",
    children: [
      {
        file: "./features/train-insights/pages/TrainInsightsLayout.tsx",
        id: "trainInsightsLayout",
        children: [
          {
            file: "./features/train-insights/pages/TrainInsightsIndex.tsx",
            id: "trainInsightsIndex",
            index: true,
          },
          {
            file: "./features/train-insights/pages/train-info/TrainInfoLayout.tsx",
            id: "trainInfoLayout",
            path: "train-info",
            children: [
              {
                file: "./features/train-insights/pages/train-info/TrainInfoRollingStock.tsx",
                id: "trainInfoIndex",
                index: true,
              },
              {
                file: "./features/train-insights/pages/train-info/TrainInfoRollingStock.tsx",
                id: "trainInfoRollingStock",
                path: "rollingstock",
              },
              {
                file: "./features/train-insights/pages/train-info/TrainInfoApc.tsx",
                id: "trainInfoApc",
                path: "apc",
              },
              {
                file: "./features/train-insights/pages/train-info/TrainInfoTraffic.tsx",
                id: "trainInfoTraffic",
                path: "traffic",
              },
              {
                file: "./features/train-insights/pages/train-info/TrainInfoRealtime.tsx",
                id: "trainInfoRealtime",
                path: "realtime",
              },
              {
                file: "./features/train-insights/pages/train-info/TrainInfoEvents.tsx",
                id: "trainInfoEvents",
                path: "events",
              },
            ],
          },
          {
            file: "./features/train-insights/pages/stations/StationsLayout.tsx",
            id: "stationsLayout",
            path: "stations",
            children: [
              {
                file: "./features/train-insights/pages/stations/StationsIndex.tsx",
                id: "stationsIndex",
                index: true,
              },
              {
                file: "./features/train-insights/pages/stations/StationsDepartures.tsx",
                id: "stationsDepartures",
                path: "departures",
              },
              {
                file: "./features/train-insights/pages/stations/StationsArrivals.tsx",
                id: "stationsArrivals",
                path: "arrivals",
              },
              {
                file: "./features/train-insights/pages/stations/StationsActivities.tsx",
                id: "stationActivities",
                path: "activities",
              },
            ],
          },
          {
            file: "./features/train-insights/pages/rolling-stock/RollingStockLayout.tsx",
            id: "rollingStockLayout",
            path: "rolling-stock",
            children: [
              {
                file: "./features/train-insights/pages/rolling-stock/RollingStockIndex.tsx",
                id: "rollingStockIndex",
                index: true,
              },
              {
                file: "./features/train-insights/pages/rolling-stock/RollingStockMap.tsx",
                id: "rollingStockMap",
                path: "map",
              },
              {
                file: "./features/train-insights/pages/rolling-stock/RollingStockRosters.tsx",
                id: "rollingStockRosters",
                path: "rosters",
              },
              {
                file: "./features/train-insights/pages/rolling-stock/RollingStockInformation.tsx",
                id: "rollingStockInformation",
                path: "information",
              },
            ],
          },
          {
            file: "./features/train-insights/pages/events/Events.tsx",
            path: "events",
          },
        ],
      },
    ],
  },
] as const satisfies DeepReadonly<RouteConfigEntry[]>;

// TODO: Consider defining a catchall for desktop routes and redirect to / for non-trainInsights users
export const TOPAS_2_SELF_DEFINED_ROUTES = [] as const satisfies DeepReadonly<
  RouteConfigEntry[]
>;
